import { JSX } from "react";

import { Navigate } from "@tanstack/react-router";

export function CustomIndexRouteComponent(): JSX.Element {
  return <Navigate to="/opportunities" />;
}
